/**
 * 操作权限处理
 */
import store from '@/store'

export default {
    mounted(el, binding, vnode) {
        const {value} = binding
        const all_permission = "*:*:*";
        let permissions = store.state && store.state.permissions
        if (value && value instanceof Array && value.length > 0) {
            const permissionFlag = value
            permissions = JSON.parse(permissions);

            const hasPermissions = permissions.some(permission => {
                return all_permission === permission || permissionFlag.indexOf(permission)!==-1
            })

            if (!hasPermissions) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`请设置操作权限标签值`)
        }
    }
}
